// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "insurance-2bEgv";
var _3 = "logo-2mJ7b";
var _4 = "title-1s2WA";
var _5 = "description-ZCglx";
var _6 = "priceWrapper-1l71X";
var _7 = "price-2ig9b";
var _8 = "iconsWrapper-3WgPC";
var _9 = "loadingIcon-2Qplk";
var _a = "loadingIconColor-khF0h";
var _b = "insideStepBar-Us-yb";
var _c = "popup-2wayj";
var _d = "downloadPopup-3R17H";
export { _1 as "__esModule", _2 as "insurance", _3 as "logo", _4 as "title", _5 as "description", _6 as "priceWrapper", _7 as "price", _8 as "iconsWrapper", _9 as "loadingIcon", _a as "loadingIconColor", _b as "insideStepBar", _c as "popup", _d as "downloadPopup" }
export default { "__esModule": _1, "insurance": _2, "logo": _3, "title": _4, "description": _5, "priceWrapper": _6, "price": _7, "iconsWrapper": _8, "loadingIcon": _9, "loadingIconColor": _a, "insideStepBar": _b, "popup": _c, "downloadPopup": _d }
